import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { Observable } from 'rxjs';
import { FeatureFlagStore, FeatureFlagState } from './feature-flag.store';

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagQuery extends Query<FeatureFlagState> {
  constructor(protected store: FeatureFlagStore) {
    super(store);
  }

  selectAll(): Observable<FeatureFlagState> {
    return this.select((state: FeatureFlagState) => state);
  }

  selectByKey(key: string): Observable<boolean> {
    return this.select((state: FeatureFlagState) => (state[key] ? state[key] : false));
  }

  getValueByKey(key: string): boolean {
    const state = this.getValue();

    return state[key] ? state[key] : false;
  }
}
